import React, { useState } from 'react';
import { X } from './icons';

interface ShareChatDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  chatId: string | null;
}

export function ShareChatDialog({ open, onOpenChange, chatId }: ShareChatDialogProps) {
  const [isCopied, setIsCopied] = useState(false);
  
  if (!open || !chatId) return null;

  const publicUrl = `${window.location.origin}/view/${chatId}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      setIsCopied(true);
      // Reset the copied state after 2 seconds
      setTimeout(() => setIsCopied(false), 2000);
    } catch (_) {
      // no-op
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-zinc-900 rounded-lg shadow-lg max-w-md w-full relative border border-zinc-700 text-white">
        <div className="absolute top-0 right-0 p-4">
          <button onClick={() => onOpenChange(false)} className="text-zinc-400 hover:text-white focus:outline-none">
            <X size={24} />
          </button>
        </div>
        <div className="p-6">
          <h2 className="text-xl font-bold mb-2">Share Chat</h2>
          <p className="text-zinc-400 text-sm mb-4">
            This chat is now public. Share the link below with anyone to let them view it.
          </p>
          <div className="flex items-center gap-2">
            <input
              readOnly
              value={publicUrl}
              className="flex-1 bg-zinc-800 border border-zinc-700 rounded px-3 py-2 text-sm"
            />
            <button onClick={copy} className="px-3 py-2 bg-emerald-600 hover:bg-emerald-700 rounded text-sm">
              {isCopied ? 'Copied!' : 'Copy'}
            </button>
          </div>
          <div className="mt-4 text-right">
            <button
              onClick={() => onOpenChange(false)}
              className="px-4 py-2 bg-zinc-700 hover:bg-zinc-600 rounded"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
